<template>
    <div class="container">
        <h3 class="title">{{langConfig[lang].titleControl}}</h3>
        <div class="progress-bar">
            <progress id="progress" :value="progress" max="100"></progress>
        </div>

        <div class="tasks">
            <task v-for="(task, index) in 6"
            :key="index"
            :id="index"
            :name="module.modules[index][lang].title"
            :status="module.modules[index].status"
            @click="openSection(index)"
            ></task>
        </div>
    </div>
</template>

<script>
import modulesData from "../assets/modules.json";
import configLang from "../assets/config.json";

    export default {
        props: ["progress", "lang"],
        data() {
            return {
                langConfig: configLang,
                module: modulesData,
            }
        },
        methods: {
            openSection(id) {
                if(this.module.modules[id].status != "lock") {
                    this.module.modules[id].isOpen = true;
                }
            }
        },
    }
</script>

<style lang="scss" scoped>

    .container {
        margin: 0;
        padding: 20px;
    }
    .title {
        font-size: 18px;
        text-align: center;
        margin-bottom: 10px;
    }

    #progress {
        width: 98%;
        height: 30px;
    }

    @media only screen and (max-width: 800px){
        .title {
            font-size: 17px !important;
        }
    }
      

</style>